import React from 'react';
import './AddPdText.scss';

function AddPdText(props) {
  const {
    isPdOnly,
    setSheet,
    dataLocale,
    preCheckout,
    setPrescriptionModal,
    listing,
    userInfo,
    orderSuccess,
    item,
  } = props;
  const { SUBMIT_PD_TO_COMPLETE_ORDER, ADD_PD } = dataLocale;
  const handleAddPd = () => {
    let pageName;
    if (orderSuccess) pageName = 'post-purchase-order-success';
    else if (listing) pageName = 'post-purchase-order-listing';
    else pageName = 'post-purchase-order-detail';
    const dlUpdate = {
      event: 'cta_click',
      cta_flow_and_page: pageName,
      cta_name: 'add-pd',
      customer_id: userInfo?.id,
      lk_user_type: userInfo?.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
    };
    if (typeof window.dataLayer !== 'undefined') window.dataLayer.push(dlUpdate);
    else {
      setTimeout(() => {
        window.dataLayer.push(dlUpdate);
      }, 2000);
    }
    setSheet(true);
    if (preCheckout) {
      setPrescriptionModal(item);
    }
  };
  return (
    <>
      {!isPdOnly && (
        <div className="addPd display-flex justify-space-between padding-15 margin-b10 margin-t10 margin-l15 margin-r15 bora-8">
          {SUBMIT_PD_TO_COMPLETE_ORDER}
          <span
            className="addPd-btn fw700 fs14 cursor-pointer lh-16 text-uppercase"
            onClick={handleAddPd}
          >
            {ADD_PD}
          </span>
        </div>
      )}
    </>
  );
}

export default AddPdText;
